<template>
    <div class="main-body">
        <h2>{{ $strings('spsite/tpl/title') }}</h2>
        <div class="action-bar">
            <div class="add-wrapper">
            </div>
            <div class="filter-wrapper">
                <el-form :inline="true" :model="formFilter" class="demo-form-inline" ref="filter">
                    <el-form-item label="">
                        <FilterCp class="max-width-120" v-model="formFilter.cp_id" @load="loadCp"/>
                    </el-form-item>
                    <el-form-item>
                        <FilterReview class="max-width-120" v-model="formFilter.tpl_status"/>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onFilter" size="small">{{
                                $strings('word/query')
                            }}
                        </el-button>
                        <el-button @click="onReset" size="small">{{ $strings('word/reset') }}</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="data-area">
            <el-table
                v-loading="loading"
                border
                :data="tableData"
                class="min-table"
                style="width: 100%">
                <el-table-column prop="cp_id" :label="$strings('word/cp_id')" width="100">
                    <template slot-scope="scope"><span class="code-text">{{ scope.row.cp_id }}</span></template>
                </el-table-column>
                <el-table-column prop="cp_id" :label="$strings('word/cp_name')" width="100">
                    <template slot-scope="scope"><span>{{ mapping.cps[scope.row.cp_id] }}</span></template>
                </el-table-column>
                <el-table-column prop="tpl_id" :label="$strings('word/id')" width="100">
                    <template slot-scope="scope"><span class="code-text">{{ scope.row.tpl_id }}</span></template>
                </el-table-column>
                <el-table-column prop="tpl_name" :label="$strings('word/name')" width="120"
                                 show-tooltip-when-overflow></el-table-column>
                <el-table-column prop="tpl_status" :label="$strings('word/status')" width="100">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.remark" placement="top-start"
                                    v-if="scope.row.tpl_status === statusRejected">
                            <el-link type="warning">
                                {{ $strings('cpsite/tpl/tpl_status_str/' + scope.row.tpl_status) }}
                            </el-link>
                        </el-tooltip>
                        <el-link :underline="false" v-else>
                            {{ $strings('cpsite/tpl/tpl_status_str/' + scope.row.tpl_status) }}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="tpl_content" :label="$strings('word/content')"
                                 show-tooltip-when-overflow></el-table-column>
                <el-table-column prop="ct_time" label="CreateTime" width="160">
                    <template slot-scope="scope">
                        {{ convertUnixToDate(scope.row.ct_time) }}
                    </template>
                </el-table-column>
                <el-table-column label="Edit" width="100">
                    <template slot-scope="scope">
                        <el-button size="small" @click="onEdit(scope.row)">{{ $strings('word/review') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination margin-top-1" v-if="pagination.total > pagination.size" style="text-align: right">
                <el-pagination background layout="prev, pager, next" :total="pagination.total"
                               :page-size.sync="pagination.size"
                               :current-page.sync="pagination.page" @current-change="refreshData"></el-pagination>
            </div>
        </div>
        <el-dialog
            :title="$strings('word/review')"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            @closed="onClose"
            width="30%">
            <div>
                <el-form ref="form" :model="editForm" label-width="80px" :rules="rules">
                    <el-form-item :label="$strings('word/content')" prop="tpl_content" readonly>
                        <el-input type="textarea" rows="4" v-model="editForm.tpl_content"></el-input>
                    </el-form-item>
                    <el-form-item :label="$strings('spsite/tpl/select_action')">
                        <FilterReview v-model="editForm.tpl_status"/>
                    </el-form-item>
                    <el-form-item :label="$strings('word/remark')" prop="remark"
                                  v-if="editForm.tpl_status*1===statusRejected">
                        <el-input type="textarea" v-model="editForm.remark" clearable maxlength="24"
                                  show-word-limit></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{ $strings('word/cancel') }}</el-button>
                <el-button type="primary" @click="onResolve()" :loading="saving">{{ $strings('word/confirm') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {API_STATUS_CODE, STORAGE_KEY_LOGIN_TZ, TPL_STATUS} from "@/config/config";
import {GetItem} from "@/utils/storage";
import {SpSiteTplRead, SpSiteTplReject, SpSiteTplResolve} from "@/api/spsite/api";
import {UnixToDateFull} from "../../../utils/time";
import FilterCp from '@/components/filter/cp';
import FilterReview from '@/components/filter/review';

export default {
    name: "cpsite-tpl",
    components: {FilterCp, FilterReview},
    data() {
        return {
            loading: true,
            saving: false,
            editForm: {},
            formFilter: {},
            tableData: [],
            dialogVisible: false,
            statusRejected: TPL_STATUS.REJECTED,
            rules: {
                remark: [
                    {required: true, message: this.$strings('word/field_empty'), trigger: 'blur'}
                ],
            },
            mapping: {cps: {}},
            pagination: {total: 0, size: 10, page: 1}
        }
    },
    mounted() {
        this.refreshData();
    },
    computed: {},
    methods: {
        loadCp(cps) {
            this.mapping.cps = {};
            cps.forEach((item) => {
                this.mapping.cps[item.cp_id] = item.cp_name;
            })
        },
        convertUnixToDate(ts) {
            let tz = parseInt(GetItem(STORAGE_KEY_LOGIN_TZ))
            return UnixToDateFull(ts, tz);
        },
        onFilter() {
            this.refreshData();
        },
        onReset() {
            this.formFilter = {};
            this.refreshData();
        },
        onClose() {
            this.saving = false
            this.$refs["form"].clearValidate();
        },
        onEdit(row) {
            this.editForm = JSON.parse(JSON.stringify(row));
            this.dialogVisible = true;
        },
        onResolve() {
            this.saving = true;
            let action = this.editForm.tpl_status * 1 === this.statusRejected ? SpSiteTplReject : SpSiteTplResolve;
            action(this.editForm).then((resp) => {
                if (resp.data.code === API_STATUS_CODE.SUCCESS) {
                    this.dialogVisible = false;
                    this.refreshData();
                }
            }).finally(() => {
                this.loading = false;
            })
        },
        refreshData() {
            this.loading = true;
            this.formFilter.size = this.pagination.size;
            this.formFilter.page = this.pagination.page;
            SpSiteTplRead(this.formFilter).then((resp) => {
                this.tableData = resp.data.data.total > 0 ? resp.data.data.rows : [];
                this.pagination.total = resp.data.data.total;
            }).finally(() => {
                this.loading = false;
            })
        },
    }
}
</script>

<style scoped lang="scss">
.action-bar {
    display: flex;
    flex-direction: row;

    .filter-wrapper {
        display: flex;
        justify-content: flex-end;
        flex-grow: 1;
    }

    .add-wrapper {
        padding-top: 4px;
    }
}

.table-pagination {
    margin-top: 1em;
    display: flex;
    justify-content: flex-end;
}
</style>